import { createApp } from "vue";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./i18n";
import dialog from "./components/Dialog";
import YouTube from "./components/YouTube";
import StaticImage from "./components/StaticImage.vue";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.css";
import "@/assets/css/hitrust.css";
import $ from "jquery";
import moment from "moment";
import env from "@/utils/env";
import ApiUtil from "@/utils/ApiUtil";

const app = createApp(App).use(store).use(router);

declare global {
  interface Window {
    $: any;
    vue: any;
  }
}

app.use({
  install: function (Vue, options) {
    Vue.config.globalProperties.goTo = function (path) {
      if (path == "back") {
        router.back();
      } else if (typeof path === "object") {
        router.push(path);
      } else if (path.startsWith("/")) {
        router.push(path);
      } else {
        const fullPath = this.$route.fullPath;
        router.push(fullPath + "/" + path);
      }
    };
    Vue.config.globalProperties.hasRoute = function (routerName) {
      return router.hasRoute(routerName);
    };

    window.vue = Vue;
    window.$ = $;
  },
});

app.config.globalProperties.$filters = {
  time(value, format) {
    if (value) {
      const d = new Date(value);
      if (d instanceof Date && !isNaN(d.getTime())) {
        return moment(d).format(format || "YYYY/MM/DD");
      } else {
        return moment(String(value)).format(format || "YYYY/MM/DD");
      }
    }
  },
};

app.use(i18n);
app.use(dialog);
app.use(YouTube);
app.component("StaticImage", StaticImage);

const envObj = new env();

envObj.init(async function () {
  app.config.globalProperties.env = envObj;
  app.config.globalProperties.ApiUtil = new ApiUtil(
    app.config.globalProperties
  );
  await router.isReady();
  app.mount("#app");
});
